<template>
  <div class="d-flex flex-column align-center flex-grow-1">
    <div>
      <div
        :style="
          insets && insets.top > 0
            ? `margin-top: calc(${insets.top}px + 12px)`
            : 'margin-top: 12px'
        "
        class="primary rounded-pill px-2 d-flex align-center return-button ml-2"
        @click="$router.push('/islands')"
      >
        <v-btn icon>
          <v-icon color="white" size="17">mdi-arrow-left</v-icon>
        </v-btn>

        <span class="body-2 white--text pr-1">
          {{ $t("islands.back_button") }}
        </span>
      </div>

      <v-img
        :aspect-ratio="16 / 9"
        width="100vw"
        :src="image"
        @error="onImageError"
        class="mb-1"
      />
      <div class="d-flex flex-column px-2">
        <div class="d-flex align-center ma-2">
          <span class="primary--text text--darken-2 text-h6 mr-auto">{{
            currentArea.name
          }}</span>

          <lottie
            :options="defaultOptions"
            :height="35"
            :width="35"
            class="pa-0 ma-0 pb-1"
            v-if="playing"
          />

          <v-btn
            v-if="!isLanguageSupported"
            icon
            class="warning-button"
            @click="dialog = true"
          >
            <v-icon color="white" class="warning rounded-circle" size="20">
              mdi-alert-circle-outline
            </v-icon>
          </v-btn>

          <v-btn
            icon
            :class="
              playDescirption || !isLanguageSupported ? '' : 'pulse-button'
            "
            @click="play"
            :disabled="!isLanguageSupported"
          >
            <v-icon
              :color="isLanguageSupported ? 'accent ' : 'grey'"
              class="rounded-circle"
              size="25"
            >
              mdi-play-circle-outline
            </v-icon>
          </v-btn>

          <v-btn icon @click="stop" :disabled="!playing">
            <v-icon
              :color="playing ? 'accent ' : 'grey'"
              class="rounded-circle"
              size="25"
            >
              mdi-stop-circle-outline
            </v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>

        <div
          class="d-flex flex-column align-start justify-space-between px-2 py-4"
        >
          <span class="body-2 mb-16" v-html="currentArea.description"> </span>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" fullscreen>
      <Instructions @close="dialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { TextToSpeech } from "@capacitor-community/text-to-speech";
import { decodeEntities } from "../../utils/decodeEntities";
import Lottie from "vue-lottie";
import animationData from "@/assets/audio_playing.json";
import Instructions from "@/components/Instructions.vue";
export default {
  components: {
    lottie: Lottie,
    Instructions,
  },

  async created() {
    if (this.autoPlayTTS && this.isLanguageSupported) await this.play();
  },

  async destroyed() {
    try {
      await this.stop();
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      tooltip: true,
      failed_image: false,
      defaultOptions: { animationData: animationData },

      playDescirption: false,

      dialog: false,
    };
  },

  computed: {
    ...mapState({
      mobileLang: (state) => state.base.mobileLang,
      currentArea: (state) => state.areas.currentArea,
      sound: (state) => state.base.sound,
      isLanguageSupported: (state) => state.base.isLanguageSupported,
      autoPlayTTS: (state) => state.base.autoPlayTTS,
      playing: (state) => state.base.isPlaying,
      insets: (state) => state.base.insets,
    }),

    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },

    decodedDescription() {
      return decodeEntities(this.currentArea.description);
    },

    image() {
      return this.failed_image
        ? "https://iguide.mobics.gr/images//ilioupoli_opt_.jpg"
        : `https://api.e-naxios.com/images/${this.currentArea.image.file_name}`;
    },
  },

  methods: {
    ...mapMutations(["togglePlaying"]),
    ...mapActions(["toggleSound"]),

    onImageError() {
      this.failed_image = true;
    },

    async play() {
      try {
        if (this.sound == "0") {
          this.$store.commit("toggleSnackbar", {
            open: true,
            text: this.$t("error_messages.unmute"),
            color: "secondary",
          });
          return;
        }
        this.playDescirption = true;
        this.togglePlaying(true);

        await TextToSpeech.speak({
          text: this.decodedDescription,
          lang: this.mobileLang.code,
          // rate: 0.9,
          pitch: 1.0,
          volume: 1.0,
          category: "playback",
        });
        this.togglePlaying(false);
      } catch (e) {
        this.togglePlaying(false);

        console.log(e);
      }
      this.togglePlaying(false);
    },

    async stop() {
      try {
        await TextToSpeech.stop();
        this.togglePlaying(false);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.return-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.warning-button {
  -webkit-animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 rgba(#ffc107, 0.5);
}

.warning-button:hover {
  -webkit-animation: none;
}
.pulse-button {
  -webkit-animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 rgba(#5a99d4, 0.5);
}

.pulse-button:hover {
  -webkit-animation: none;
}

@-webkit-keyframes pulse {
  0% {
    // transform: scale(1);
  }
  70% {
    // transform: scale(1.05);
    box-shadow: 0 0 0 5px rgba(90, 153, 212, 0);
  }
  100% {
    // transform: scale(1);
    box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
  }
}
</style>